// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../setISOWeekYear/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var setISOWeekYear = convertToFP(fn, 2);
export default setISOWeekYear;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/setISOWeekYear/index.js
// module id = 975
// module chunks = 0